/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Slobodan Djordjevic
 */
import React from "react";
import {Element, TopBar} from "trux";
import traceLogoBlack from "../../assets/img/traceLogoBlack.svg";

import './SimpleTopBar.css';

export const SimpleTopBar = () => {

  return (
    <TopBar>
      <Element className="top-bar-trace-logo-black" tag="img" src={traceLogoBlack} alt='logo'/>
    </TopBar>
  )
}